import { gql } from "@apollo/client"

/**
 * Appointments list query with filters
 *
 * Variables:
 * - page?: Int
 * - limit?: Int (default 100 for day/week views)
 * - filters?: { dateFrom, dateTo, status, email, staffId }
 */
export const GET_APPOINTMENTS = gql`
  query Appointments(
    $page: Int
    $limit: Int
    $filters: AppointmentFiltersInput
  ) {
    appointments(
      pagination: { page: $page, limit: $limit }
      filters: $filters
    ) {
      data {
        id
        appointment_date
        appointment_time
        status
        isHomeService
        isPaymentComplete
        paymentReference
        isCustomBooking
        groupId
        beneficiaryName
        notes
        startTime
        endTime
        beforeImage
        afterImage
        staffId
        staff {
          id
          userId
          role
          isActive
          user {
            id
            email
            profile {
              firstName
              lastName
              avatar
            }
          }
        }
        user {
          id
          email
          profile {
            firstName
            lastName
            gender
            avatar
            phone
            location {
              address
            }
          }
        }
        service {
          id
          service_name
          service_price
          service_duration
        }
        services {
          id
          service_name
          service_price
          service_duration
        }
        costing {
          id
          service_price
          vat_amount
          tax_amount
          deposit_amount
          remaining_amount
          service_fee
          processing_fee
          total_amount
          is_total_overridden
          overridden_total_amount
        }
      }
      meta {
        total
        page
        limit
        totalPages
        hasNext
        hasPrevious
      }
    }
  }
`

/**
 * Single appointment query
 */
export const GET_APPOINTMENT = gql`
  query Appointment($id: ID!) {
    appointment(id: $id) {
      id
      appointment_date
      appointment_time
      status
      isHomeService
      isPaymentComplete
      notes
      user {
        id
        email
      }
      service {
        id
        service_name
        service_price
        service_duration
      }
      services {
        id
        service_name
        service_price
        service_duration
      }
      costing {
        id
        service_price
        vat_amount
        tax_amount
        deposit_amount
        remaining_amount
        service_fee
        processing_fee
        total_amount
        is_total_overridden
        overridden_total_amount
      }
      createdAt
      updatedAt
    }
  }
`


